// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1MlqL","empty":"ModalGraph_empty__1b5tY"};